var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUpdate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M16 40.55q-5.85 0-9.925-4.075Q2 32.4 2 26.55q0-6.15 4.375-10.025T16.15 13l-4.3-4.3L14 6.55l8 8-8 8-2.15-2.15 4.45-4.45q-4.75-.1-8.025 2.9Q5 21.85 5 26.55q0 4.55 3.225 7.775Q11.45 37.55 16 37.55h6v3Zm10-18v-14h18v14Zm0 18v-14h18v14Zm3-3h12v-8H29Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpdate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/update.c68e6b39.svg";
export { ForwardRef as ReactComponent };